import { createSlice } from '@reduxjs/toolkit';
import { getAuthUser } from '../util/auth';

const currentUser = getAuthUser();

const initialAuthState = {
    isAuth: currentUser ? true : false,
    user: currentUser,
}

const authSlice = createSlice({
    name: 'auth',
    initialState: initialAuthState,
    reducers: {
        login(state, actions) {
            state.isAuth = true;
            state.user = {
                userId: actions.payload.userId,
                workspaceId: actions.payload.workspaceId,
                workspaceName: actions.payload.workspaceName,
                name: actions.payload.name,
                firstName: actions.payload.firstName,
                lastName: actions.payload.lastName,
                email: actions.payload.email,
                profileImage: actions.payload.profileImage,
                workspaces: actions.payload.workspaces
            }
        },
        logout(state) {
            state.isAuth = false;
            state.user = null;
        }
    }
})

export const authActions = authSlice.actions;
export default authSlice;